import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./FlightResults.css";
import FlightBookingModal from "./FlightBookingModal";

const FlightResults = ({flightresults}) => {
  const location = useLocation();
  const { results } = location.state || { results: flightresults };
  const [selectedFlight, setSelectedFlight] = useState(null);

  return (
    <>
    <section className="flight-results-section">
      <h2 className="flight-results-heading">Available Flights</h2>

      {results.length > 0 ? (
        <div className="flight-cards-list">
          {results.map((flight, idx) => {
            const itinerary = flight.itineraries?.[0];
            const segment = itinerary?.segments?.[0];
            const carrier = segment?.carrierCode || "N/A";
            const fromAirport = segment?.departure?.iataCode || "N/A";
            const toAirport = segment?.arrival?.iataCode || "N/A";
            const departureTime = new Date(segment?.departure?.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            const arrivalTime = new Date(segment?.arrival?.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            const departureDate = new Date(segment?.departure?.at).toLocaleDateString();
            const arrivalDate = new Date(segment?.arrival?.at).toLocaleDateString();
            const price = flight.price?.total || "N/A";
            const duration = itinerary?.duration?.replace("PT", "").toLowerCase() || "N/A";
             const seatsLeft = Math.floor(Math.random() * 10) + 3;
            return (
              <div key={idx} className="flight-card-large">
                <div className="flight-card-large-header">
                  <div className="airline-info">
                    <img
                      src={`https://content.airhex.com/content/logos/airlines_${carrier.toLowerCase()}_200_200_s.png?proportions=keep`}
                      onError={(e) => { e.target.src = "/placeholder-airline.png"; }}
                      alt={carrier}
                      className="airline-logo"
                    />
                    <div>
                      <div className="airline-name">{carrier}</div>
                      <div className="flight-code">{flight.validatingAirlineCodes?.join(", ")}</div>
                    </div>
                  </div>
                  <div className="flight-times">
                    <span className="time">{departureTime}</span>
                    <span className="arrow">→</span>
                    <span className="time">{arrivalTime}</span>
                  </div>
                  <div className="flight-duration">
                    {duration}
                  </div>
                  <div className="airport-codes">
                    <span>{fromAirport}</span> to <span>{toAirport}</span>
                  </div>
                  <div className="flight-price-tag">
                    ₹{Number(price).toLocaleString()}
                    <div className="fare-type">Economy</div>
                    <div className="refundable">Refundable</div>
                  </div>
                 <button
  className="book-flight-btn"
  onClick={() => setSelectedFlight(flight)}
>
  Book
</button>

                </div>
                <div className="flight-card-footer">
                  <button className="details-btn">View Details</button>
                  <span className="seats-left">Seats left: {seatsLeft}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="no-results">No flights found. Please Search Again.</p>
      )}
    </section>
    {selectedFlight && (
  <FlightBookingModal
    flight={selectedFlight}
    onClose={() => setSelectedFlight(null)}
    onSubmit={(formData) => {
      console.log("Booking confirmed!", formData);
      alert(`Booking confirmed for ${formData.name}`);
      setSelectedFlight(null);
    }}
  />
)}

    </>
  );
};

export default FlightResults;
